/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Faq_OverlineInputs */

const en_dr_faq_overline = /** @type {(inputs: Dr_Faq_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

const id_dr_faq_overline = /** @type {(inputs: Dr_Faq_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanya jawab`)
};

/**
* | output |
* | --- |
* | "FAQ" |
*
* @param {Dr_Faq_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_faq_overline = /** @type {((inputs?: Dr_Faq_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Faq_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_faq_overline(inputs)
	return en_dr_faq_overline(inputs)
});